<template>
  <div class="select-field-widget field is-full-width">
    <label :for="inputId" class="label_for primary-color text-uppercase font-weight-bold" v-if="title">{{title}}</label>
    <vue-select
            :id="inputId"
            :options="selectOptions"
            :label="label"
            :value="inputModel"
            :disabled="isDisabled"
            @input="onChange"
            :components="{OpenIndicator}"
            :searchable="isDesktop">
      <template v-slot:option="option" >
        <div v-show="option.active">
          <span :class="option.icon"></span>
          {{ option[label] }}
        </div>
      </template>

      <span slot="no-options">{{$t('no_results_found')}}</span>
    </vue-select>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {isMobile} from '@/components/utils/utils';

  @Component({})
    export default class SelectFieldWidget extends Vue {

        @Prop(Array) inputOptions!: any[];
        @Prop() initialSelected!: any;
        @Prop(String) title!: string;
        @Prop(String) inputName!: string;
        @Prop({type: String, default: 'name'}) label!: string;
        @Prop(Boolean) isRequired!: boolean;
        @Prop(Boolean) isDisabled!: boolean;
        @Prop(Boolean) unSelectFirst!: boolean;
        @Prop(Boolean) isSearchable!: boolean;
        @Prop(String) emptyDescription!: string;
        @Prop({type: String, default: 'bp-Form'}) formName!: string;

        private inputModel: any = {};
        private selectOptions: any[] = [];
        private inputId: string = '';
        private htmlName: string = '';
        private emptyDesc: string = '';

        OpenIndicator:Object = {
            render: (createElement:any) => createElement('span', {class: {'select-arrow': true}})
        } as any;

        created() {

            this.inputId = 'input' + this.inputName;
            this.htmlName = this.inputName || this.title;
            if (this.formName) {
                this.inputId = this.formName + "." + this.inputId;
            }
        }

        mounted() {
            if (!this.initialSelected) {
                this.emptyDesc = '(' + this.$t(this.emptyDescription || (this.isRequired ? 'choose' : 'all')) + ')';
                const emptyOption: any = {};
                emptyOption[this.label] = this.emptyDesc;
                this.selectOptions = [emptyOption, ...this.inputOptions];
            } else {
                // let filteredOptions: Array<any> = this.inputOptions.filter(el => el.id !== this.initialSelected.id);
                this.inputOptions.sort((a, b) => a === this.initialSelected ? -1 :b === this.initialSelected?1:0 )
                this.selectOptions = this.inputOptions;
            }

            if (this.initialSelected) {
                this.inputModel = this.initialSelected;
            } else if (this.inputOptions.length > 0 && !this.unSelectFirst) {
                this.inputModel = this.inputOptions[0];
            } else {
                this.inputModel = this.selectOptions[0];
            }
        }

        onChange(selected: any): void {
            if (typeof selected === 'string' && !!selected && selected.length > 0) {
                this.updateModel(selected);
            } else if (Object.keys(selected).length > 0) {
                this.updateModel(selected);
            }
        }

        updateModel(selected: any) {
            this.inputModel = selected;
            this.$emit('input', selected[this.label] === this.emptyDesc ? null : selected);
            this.$emit('change');
        }


        get isDesktop(){
            return !isMobile();
        }

    }

</script>

<style scoped lang="scss">



  .select-field-widget {

    .label_for{
      margin-bottom: 10px;
      display: block;
    }
    ::v-deep .v-select {
      .vs__dropdown-toggle {
        background: white;
        box-sizing: border-box;
        height: 60px;
        max-width: 495px;
        border-radius: 5px;

        .vs__selected {
          height: 50px;
          margin: 0;
          position: absolute;
          color: #151E41;

        }

      }


      .vs__search::placeholder,
      .vs__dropdown-toggle,
      .vs__dropdown-menu {
        color: #394066;
        text-transform:capitalize;
        font-weight: 600;
        border: 1px solid #151E41;
        padding-left: 0;

        box-sizing: border-box;
        max-width: 495px;
        border-radius: 5px;
        font-size: 19px;
        line-height: 45px;
      }


      .vs__open-indicator {
        fill: $secondary-color;
        cursor: pointer;
      }

      .vs__dropdown-menu {
        .vs__dropdown-option{
          color: #394066;

        }
        .vs__dropdown-option--highlight{
          background-color: #F7F9FB;
          color: initial;
        }

        z-index: 8;
      }

    }
  }

</style>
